import { ColDef } from "ag-grid-community"
import pdfMake from "pdfmake/build/pdfmake"
import pdfFonts from "pdfmake/build/vfs_fonts"
import { IPrintParams } from "../components/table/FlightTableGrid"

import getDocDefinition from "./docDefinition"

pdfMake.vfs = pdfFonts.pdfMake.vfs

function printDoc(
  printParams: IPrintParams,
  gridApi: ColDef[],
  columnApi: ColDef[],
  title: string
) {
  const docDefinition = getDocDefinition(printParams, gridApi, columnApi)

  pdfMake.createPdf(docDefinition).download(`${title}.pdf`)
}

export default printDoc
